import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
//import { CdkDragDrop, moveItemInArray, CdkDrag } from '@angular/cdk/drag-drop';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { FormBuilder } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UsersService } from "../../services/users.service";
import { NgxSpinnerService } from "ngx-spinner";
import { Router, ActivatedRoute } from "@angular/router";
import { interval, timer } from 'rxjs';
import { DatePipe } from '@angular/common';
import { jsPDF } from "jspdf";
export interface TimeSpan {
  hours: number;
  minutes: number;
  seconds: number;
}
@Component({
  selector: 'app-viewer-question',
  templateUrl: './viewer-question.component.html',
  styleUrls: ['./viewer-question.component.scss'],
  providers: [DatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewerQuestionComponent implements OnInit, OnDestroy {
  countDown: any = ''; counter: any = 0;
  tick = 1000;
  currentStep: any = ''; isLastSubmodule: number = 0; modulesId: any = ''; courseStatus: Number = 1; EvaluationResults: any = [];
  assessmentType: any; spentTime: any; isPassed: Number = 3; EvaluationResult: any = []; EvaluationResultFail: any = [];
  stepper: any; assessmentAttemt: any; totleTime: any; hours: any = 0; minutes: any = 0; seconds: any = 0;
  ModulSubData: any = []; moduleName: any = ''; moduleStatus: Number = 0;
  userLoginData: any = []; assId: any = ''; assQuestinData: any = []; courseId: any = ''; moduleId: any = ''; submoduleId: any = '';
  selectOption: any = ''; selectAnswer: any = ''; proPercent: any; proPerc: any; total_time_spent: any = 1; total_question: any;
  responseData: any = [];request_status:number=1;
  private detailArray: any[] = [];currentData: any = ''; currentBaseUrl: any = '';
  selectedAnswer: any[] = []; myDate = new Date();
  selectedAnswers: any = [];CourseData: any = [];


  constructor(private changeDetector: ChangeDetectorRef, private _formBuilder: FormBuilder, private router: Router, private authUser: UsersService, private route: ActivatedRoute, private spinner: NgxSpinnerService, private datePipe: DatePipe,
    private modalService: NgbModal) {
      this.currentData = this.datePipe.transform(this.myDate, 'dd/MM/yyyy');
    if (localStorage.getItem('userLoginData') == '' || localStorage.getItem('userLoginData') == null) {
      this.router.navigateByUrl('/');
    }
    // for (let i = 0; i < this.assQuestinData.questions.length; i++) {
    //   this.dragDropAnswers.push([]);
    // }
  }
  entries = new Date(new Date().getTime());
  open(content: any) {
    this.modalService.open(content, { centered: true, size: 'sm', backdrop: 'static', keyboard: false });
  }
  openSucessModel(content: any){
    this.modalService.open(content, { centered: true, size: 'md', backdrop: 'static', keyboard: false });
  }
  openFailModel(content: any){
    this.modalService.open(content, { centered: true, size: 'md', backdrop: 'static', keyboard: false });
  }
  openSentModel(content: any){
      this.contactAdministrator(this.userLoginData.user_id,this.courseId,this.assId, this.request_status)

    this.modalService.open(content, { centered: true, size: 'md', backdrop: 'static', keyboard: false });
  }
  closeModelPopup(){
    this.modalService.dismissAll();
    this.router.navigateByUrl('/assigned');
  }
  contactAdministrator(user_id:number,course_id:any,assessment_id:any, request_status:any){
    this.spinner.show();
    this.authUser.contactAdministrator(user_id,course_id,assessment_id, request_status).subscribe(
      data=>{
        if(data.status == 401){
          document.getElementById('successMsg')?.click();
          this.spinner.hide();
        }else{
          this.spinner.hide();
        }

      },error=>{
        this.spinner.hide();
      }
    )
  }
  ngOnInit(): void {
    localStorage.removeItem('EvaluationResultFail');
    localStorage.removeItem('EvaluationResult');
    this.moduleName = JSON.parse(localStorage.getItem('moduleName') || '[]');
    //this.totalTimeSpentView = JSON.parse(localStorage.getItem('totalTimeSpent') || '[]');
    localStorage.setItem('AssessmentTimerStatus', JSON.stringify((1)));
    this.CourseData = JSON.parse(localStorage.getItem('CourseData') || '[]');
    /******prevent Angular page refresh start */
    window.addEventListener("keyup", disableF5);
    window.addEventListener("keydown", disableF5);
    function disableF5(e: any) {
      if ((e.which || e.keyCode) == 116) e.preventDefault();
    };
    /****** End */
    this.countDown = timer(0, this.tick).subscribe(() => --this.counter);
    this.userLoginData = JSON.parse(localStorage.getItem('userLoginData') || '[]');
    this.route.queryParams.subscribe(queryParams => {
      this.assId = queryParams['assId']; this.courseId = queryParams['courseId']; this.moduleId = queryParams['moduleId'];
      this.assessmentType = queryParams['AT'];
      this.submoduleId = queryParams['submoduleId'];
    });

    if (this.submoduleId != undefined) {
      this.moduleStatus = 1;
      this.ModulSubData = JSON.parse(localStorage.getItem('ModulSubData') || '[]');
    }
    if (this.assId != '' || this.assId != null) {
      this.assessmentDetail(this.assId);
      this.getAssessmentTimer();
    }
    interval(1000).subscribe(() => {
      this.changeDetector.detectChanges();
    });
    this.checkCoursesStatus(this.userLoginData.user_id, this.courseId);

  }
  ngOnDestroy() { this.countDown = null; }
  assessmentDetail(assId: any) {
    this.authUser.assessmentData(assId, this.userLoginData.user_id, this.courseId).subscribe(
      data => {
        if (data.status == 401) {
          document.getElementById('successMsg')?.click();
          this.spinner.hide();
        } else {
          this.assQuestinData = data.data;
          this.counter = this.assQuestinData.assest_time_hr * 60 * 60 + this.assQuestinData.assest_time_min * 60;
          setTimeout(() => {
            this.currentStep = this.assQuestinData.question_attempt;
            // this.currentStep = 1;
          }, 1000);
          this.proPerc = (100 / this.assQuestinData.questions.length) * (this.currentStep + 1);
        }
        // console.log(data);

      }, error => {
        //console.log(error);
      }
    )
  }
  assessmentPreQuestDetail(assId: any) {
    this.authUser.assessmentPreData(assId, this.userLoginData.user_id, this.courseId).subscribe(
      data => {
        if (data.status == 401) {
          document.getElementById('successMsg')?.click();
          this.spinner.hide();
        } else {
          this.assQuestinData = data.data;
          this.counter = this.assQuestinData.assest_time_hr * 60 * 60 + this.assQuestinData.assest_time_min * 60;
          setTimeout(() => {
            this.currentStep = this.assQuestinData.question_attempt;
          }, 1000);
          this.proPerc = (100 / this.assQuestinData.questions.length) * (this.currentStep + 1);
        }
        console.log(data.data);

      }, error => {
        // console.log(error);
      }
    )
  }
  getAssessmentTimer() {
    this.authUser.getAssessmentTime(this.userLoginData.user_id, this.courseId, this.assId).subscribe(
      data => {
        //console.log(data.time_difference);
        this.counter = (this.assQuestinData.assest_time_hr * 60 * 60 + this.assQuestinData.assest_time_min * 60) - data.time_difference;
      }, error => {
        //console.log(error);
      }
    )
  }
  /*****get answer *****/
  putAns(option: any, selectAnswer: any, type: any, QstData: any) {
    let qst = QstData;
    this.selectOption = option;
    if (type == 3) {
      this.responseData = selectAnswer;
    } else {
      this.selectAnswer = selectAnswer;
    }

  }
  showSelectedAnswer(questionIndex: number) {
    const selectedAnswer = this.selectedAnswers[questionIndex];
    this.selectAnswer = selectedAnswer;
    console.log(`Question ${questionIndex + 1} - Selected Answer: ${selectedAnswer}`);
    // You can update the UI to display the selected answer if needed.
  }
  // prevClick(){
  //   alert("hi");
  //   this.selectOption = '1';
  //   //this.selectAnswer = 1;
  // }
  /*******assessment Answer submit */
  submitQueAns(assessment_id: any, question_num: any, assessment_question_id: any, index: any) {
    // debugger;
    this.spinner.show();
    this.proPerc = (100 / this.assQuestinData.questions.length) * (index + 1);
    const inputData = {
      "user_id": this.userLoginData.user_id,
      "course_id": this.courseId,
      "module_id": this.moduleId,
      "assessment_id": assessment_id,
      "question_num": question_num,
      "question_id": assessment_question_id,
      "response_text": this.selectAnswer,
      "response_id": this.selectOption,
      "matchData": this.responseData
    };
    this.updateOrPushDetail(inputData)
    this.authUser.assessmentSubmit(this.userLoginData.user_id, this.courseId, this.moduleId, this.submoduleId, assessment_id,
      question_num, assessment_question_id, this.selectAnswer, this.selectOption, this.responseData).subscribe(
        data => {
          if (data.status == 401) {
            document.getElementById('successMsg')?.click();
            this.spinner.hide();
          } else {
            this.selectOption = ''; this.selectAnswer = '';
            this.spinner.hide();
          }

        }, error => {
          this.spinner.hide();
        }
      )
  }
  updateOrPushDetail(inputData: any) {
    const existingDetailIndex = this.detailArray.findIndex((detail) => detail.question_id === inputData.question_id);

    if (existingDetailIndex !== -1) {
      // Update the existing object if the question ID exists
      this.detailArray[existingDetailIndex] = inputData;
    } else {
      // Push a new object if the question ID doesn't exist
      this.detailArray.push(inputData);
    }
    return this.detailArray;
  }

  getDetails(QustId: number) {
    console.log(this.detailArray)
    const questionIdToMatch = QustId;
    for (const detail of this.detailArray) {
      if (detail.question_id === questionIdToMatch) {
        // Push response_id and response_text to the selectedAnswers array
        this.selectedAnswer.push({
          response_id: detail.response_id,
          response_text: detail.response_text,
        });
      }
    }
  }
  getElapsedTime() {
    this.hours = Math.floor(this.counter / 3600);
    this.minutes = Math.floor((this.counter % 3600) / 60);
    this.seconds = (Math.floor(this.counter - ((this.hours * 3600) + this.minutes * 60)));
    if (this.counter < 0) {
      // this.assessmentsEvaluation(this.assId,'','',''); //temp closed anjali
    }
    // console.log(this.hours,'-',this.minutes,'-', this.seconds)
    return { hours: this.hours, minutes: this.minutes, seconds: this.seconds };
  }
  assessmentsEvaluation(assessment_id: any, question_num: any, assessment_question_id: any, index: any) {
    this.spinner.show();
    this.assessmentAttemt = this.assQuestinData.attempt_num + 1;
    if (this.assessmentType == 0) {
      this.total_time_spent = Math.floor((((this.assQuestinData.assest_time_hr * 60 * 60 + this.assQuestinData.assest_time_min * 60) - this.counter) % 3600) / 60);
      if (this.total_time_spent < 1) { this.total_time_spent = 1; }
      this.authUser.assessmentsEvaluationSubmit(this.userLoginData.user_id, this.courseId, this.moduleId, this.submoduleId, assessment_id,
        question_num, assessment_question_id, this.selectAnswer, this.selectOption, this.total_time_spent, this.assQuestinData.questions.length, this.assessmentAttemt, this.assessmentType, this.responseData).subscribe(
          data => {
            // console.log(data,'submodule');
            if (data.data.is_passed == 1) {
              this.EvaluationResults = data.data;
              this.getModuleDetails(this.moduleId, this.submoduleId, data.data.is_passed, data.data.courseStatus);
            } else {
              localStorage.setItem('EvaluationResultFail', JSON.stringify(data.data));
              this.router.navigate(['/module_failed'], { queryParams: { assId: this.assId, isPassed: data.data.is_passed, modId: this.moduleId, subModlId: this.submoduleId, courseId: this.courseId, AT: this.assessmentType } });
              this.spinner.hide();
            }
          }, error => {
            this.spinner.hide();
          }
        )
    } else {
      this.total_time_spent = Math.floor((((this.assQuestinData.assest_time_hr * 60 * 60 + this.assQuestinData.assest_time_min * 60) - this.counter) % 3600) / 60);
      if (this.total_time_spent < 1) { this.total_time_spent = 1; }
      this.authUser.assessmentsEvaluationSubmit(this.userLoginData.user_id, this.courseId, this.moduleId, this.submoduleId, assessment_id,
        question_num, assessment_question_id, this.selectAnswer, this.selectOption, this.total_time_spent, this.assQuestinData.questions.length, this.assessmentAttemt, this.assessmentType, this.responseData).subscribe(
          data => {
            // console.log(data,"module");
            if (data.data.is_passed == 1) {
              this.EvaluationResults = data.data;
              this.getModuleDetails(this.moduleId, this.submoduleId, data.data.is_passed, data.data.courseStatus);
            } else {
              localStorage.setItem('EvaluationResultFail', JSON.stringify(data.data));
              this.router.navigate(['/module_failed'], { queryParams: { assId: this.assId, isPassed: data.data.is_passed, modId: this.moduleId, subModlId: this.submoduleId, courseId: this.courseId, AT: this.assessmentType } });
            }
          }, error => {
            this.spinner.hide();
          }
        )
    }
  }
  // finishViewSubModule(userId:any, course_id:any, module_id: any, submodule_id: any, totalTimeSpent: any,is_passed:any) {
  //   this.authUser.subModuleEndView(userId, course_id, module_id, submodule_id, totalTimeSpent).subscribe(
  //     data => {
  //       this.spinner.show();
  //       console.log(data,'end_api');
  //       this.courseStatus = data.course_status;
  //       if(is_passed == 1){
  //         this.getModuleDetails(this.moduleId,this.submoduleId,is_passed,this.courseStatus);
  //       }
  //       this.spinner.hide();
  //     }, error => {
  //       this.spinner.hide();
  //      // this.toastr.error('something went wrong');
  //     }
  //   )
  // }
  getModuleDetails(module_id: any, submoduleId: any, Ispassed: any, courseStatus: any) {
    this.authUser.getModuleDetail(module_id).subscribe(
      data => {
        // console.log(data,'getModuledetail');
        this.modulesId = data.data.module_id;
        if (this.submoduleId == data.data.submodules[data.data.submodules.length - 1].submodule_id) {
          this.assId = data.data.assessment_id;
          localStorage.setItem('EvaluationResult', JSON.stringify(this.EvaluationResults));
          this.isLastSubmodule==1;
          document.getElementById('successPopup')?.click();
          // this.router.navigate(['/module_Passed'], {
          //   queryParams: {
          //     assId: this.assId, isPassed: Ispassed, modId: this.moduleId,
          //     subModlId: this.submoduleId, courseId: this.courseId, AT: this.assessmentType, isLastSubmodule: 1, courseStatus: courseStatus
          //   }
         // });
        } else {
          this.isLastSubmodule==1;
          localStorage.setItem('EvaluationResult', JSON.stringify(this.EvaluationResults));
          document.getElementById('successPopup')?.click();
          // this.router.navigate(['/module_Passed'], { queryParams: { assId: this.assId, isPassed: Ispassed, modId: this.moduleId, subModlId: this.submoduleId, courseId: this.courseId, AT: this.assessmentType, isLastSubmodule: 0, courseStatus: courseStatus } });
        }
        this.spinner.hide();
      }, error => {
        this.spinner.hide();
        //this.toastr.error('something went wrong');
      }
    )
  }

  goViewer(modId: any, subModlId: any, courseId: any) {
    this.authUser.subModuleStartView(this.userLoginData.user_id, courseId, modId, subModlId).subscribe(
      data => {
        this.router.navigate(['/viewer'], { queryParams: { modId: modId, subModlId: subModlId, courseId: courseId } });
      }, error => {
      }
    )
  }
  navigationEvent() {
    localStorage.removeItem('userLoginData');
    this.router.navigateByUrl('/');

  }
  previousQuestionAss(question_id: any) {
    this.authUser.previousQuestion(this.userLoginData.user_id, this.courseId, this.assId, question_id).subscribe(
      data => {

        console.log(data, 'prev')
      }, error => {
      }
    )
  }
  /****incase admin make course deactive than check and redirect to assign list */
  checkCoursesStatus(user_id: number, course_id: any) {
    this.spinner.show();
    this.authUser.checkCourseStatus(user_id, course_id).subscribe(
      data => {
        if (data.exits == 0) {
          this.router.navigateByUrl('/assigned');
        }
        this.spinner.hide();
      }, error => {
        this.spinner.hide();
      }
    )
  }


  drop(event: CdkDragDrop<string[]>, index: number, selectAnswer: any) {
    this.selectOption = index + 1;
    this.responseData = selectAnswer;
    console.log(this.responseData)

    const from = event.previousIndex;
    const to = event.currentIndex;

    // Ensure you're working with the correct arrays (match_responses)
    const fromValue = this.assQuestinData.questions[index].match_responses[from].response_match;
    console.log("From_Value:", fromValue )
    const toValue = this.assQuestinData.questions[index].match_responses[to].response_match;
    console.log("To_Value:", toValue )
    // Swap the response_match values
    this.assQuestinData.questions[index].match_responses[from].response_match = toValue;
    this.assQuestinData.questions[index].match_responses[to].response_match = fromValue;

  }

  submitAnswers() {
    const submittedAnswers = [];
    this.total_time_spent = Math.floor((((this.assQuestinData.assest_time_hr * 60 * 60 + this.assQuestinData.assest_time_min * 60) - this.counter) % 3600) / 60);
    if (this.total_time_spent < 1) { this.total_time_spent = 1; }

    for (let i = 0; i < this.assQuestinData.questions.length; i++) {
      const question = this.assQuestinData.questions[i];
      const selectedAnswer = this.selectedAnswers[i];
      const selectedAnswerIndex = question.responses.findIndex((response:any) => response.response === selectedAnswer);
      const dragDropAnswers =  this.responseData;
      console.log(dragDropAnswers)

      if (selectedAnswerIndex !== -1) {
        submittedAnswers.push({
          question_num:question.question_num,
          question_text: question.question_text,
          question_id: question.assessment_question_id,
          selected_answer: selectedAnswer,
          response_id: selectedAnswerIndex+1
        });
      } else if (dragDropAnswers.length > 0) {
        submittedAnswers.push({
          question_num:question.question_num,
          question_id: question.assessment_question_id,
          question_text: question.question_text,
          selected_answer: dragDropAnswers,
        });
      } else {
        // Handle unanswered questions
        submittedAnswers.push({
          question_num:question.question_num,
          question_id: question.assessment_question_id,
          question_text: question.question_text,
          response_id:selectedAnswerIndex+1,
          selected_answer: 'No answer selected',
        });
      }
    }
    console.log('QuestionData:', submittedAnswers);
    const postJson = {
      "user_id": this.userLoginData.user_id,
      "course_id": this.courseId,
      "module_id": this.moduleId,
      "assessment_id": this.assId,
      "attempt_num": this.assQuestinData.attempt_num + 1,
      "question_data": submittedAnswers,
      "total_time_spent":this.total_time_spent,
      "total_question":this.assQuestinData.questions.length,
      "assessment_type":this.assessmentType

    };
    //console.log('FinalSubmit:', postJson);
    this.authUser.assesmentFinalSubmit(postJson).subscribe(
        data => {
          console.log(data,'hello')
          this.EvaluationResults = data.data;
          if (data.data.is_passed == 1) {
            this.getModuleDetails(this.moduleId, this.submoduleId, data.data.is_passed, data.data.courseStatus);
          } else {
            localStorage.setItem('EvaluationResultFail', JSON.stringify(data.data));
            this.spinner.hide()
            document.getElementById('failPopup')?.click();
            // this.router.navigate(['/module_failed'], { queryParams: { assId: this.assId, isPassed: data.data.is_passed, modId: this.moduleId, subModlId: this.submoduleId, courseId: this.courseId, AT: this.assessmentType } });
          }
        }, error => {
          this.spinner.hide();
        }
        )

  }
  downloadCertificate() {
    const doc = this.downloadCartiCourse()
    doc.save("course_certificate.pdf");
  }
  toTitleCase(str:any) {
    return str
      .toLowerCase()
      .split(" ")
      .map((word:any) => word[0].toUpperCase() + word.slice(1))
      .join(" ");
  }
  downloadCartiCourse() {
    this.currentData = this.datePipe.transform(this.myDate, 'dd/MM/yyyy');
    const fullName = this.toTitleCase((this.userLoginData.first_name + " " + this.userLoginData.last_name).toLowerCase());
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: "px",
      format: [550, 297],
    });
    // const doc= new jsPDF('p', 'mm', 'a4');
    var width = doc.internal.pageSize.getWidth();
    doc.setDrawColor(35, 36, 115); // draw red lines
    // TOP
    doc.setLineWidth(10);
    doc.line(0, 0, 600, 0);
    // Bottom
    doc.setLineWidth(5);
    doc.line(0, 295, 600, 295);
    //LEFT
    doc.setLineWidth(10);
    doc.line(0, 600, 0, 0);
    //RIGHT
    doc.setLineWidth(10);
    doc.line(550, 500, 550, 0);

    doc.addImage('../../../assets/images/logo.png', 'PNG', 460, 20, 70, 15);
    doc.addImage('../../../assets/images/vandhanalogo.jpeg', 'JPEG', 15, 5, 80, 50);
    doc.addFont('../../../assets/font/itcedscr-webfont.ttf', 'edwardian_script_itcregular', 'normal');
    doc.setFont('edwardian_script_itcregular');

    doc.setFontSize(50);
    doc.setTextColor(67, 67, 67);
    doc.text("Certificate of Course Completion", width / 2, 90, { align: 'center' });
    if(fullName.length < 50){
      doc.setFontSize(25);
      doc.setTextColor(67, 67, 67);
      doc.text("This is to Certify that " +`" `  + fullName + `"`+ " has successfully completed", width / 2, 123, { align: 'center' });
      if(this.CourseData.length < 50){
        doc.setLineWidth(0.5);
        // doc.line(270, 132, 210, 132);
        doc.setFontSize(27);
        doc.setTextColor(67, 67, 67);
        doc.text(`" ` + this.CourseData + `" `+ " on " + this.currentData + "", width / 2, 155, { align: 'center' });

        doc.addImage('../../../assets/images/ashish_sign.png', 'PNG', 65, 205, 60, 18);
        doc.setFont('normal');
        doc.setLineWidth(0.5);
        doc.line(50, 225, 140, 225);
        doc.setFontSize(12);
        doc.setTextColor(35, 66, 125);
        doc.text("Ashish Agarwal", 63, 235);
        doc.text("Sr. Training Manager", 57, 250);

        doc.addImage('../../../assets/images/bage.png', 'PNG', 260, 185, 52, 70);
        doc.addImage('../../../assets/images/divakarSign.png', 'PNG', 420, 205, 65, 20);
        doc.setFont('normal');
        doc.setLineWidth(0.5);
        doc.line(498, 225, 415, 225);
        doc.setFontSize(12);
        doc.setTextColor(35, 66, 125);
        doc.text("Diwakar Dubey", 425, 235);
        doc.text("Training Manager", 420, 250);
      }else{
        doc.setLineWidth(0.5);
        // doc.line(270, 132, 210, 132);
        doc.setFontSize(27);
        doc.setTextColor(67, 67, 67);
        doc.text(`" ` + this.CourseData + `" ` , width / 2, 155, { align: 'center' });
        doc.setFontSize(27);
        doc.setTextColor(67, 67, 67);
        doc.text(" on " + this.currentData + "", width / 2, 180, { align: 'center' });

        doc.addImage('../../../assets/images/ashish_sign.png', 'PNG', 65, 225, 60, 18);
        doc.setFont('normal');
        doc.setLineWidth(0.5);
        doc.line(50, 245, 140, 245);
        doc.setFontSize(12);
        doc.setTextColor(35, 66, 145);
        doc.text("Ashish Agarwal", 63, 255);
        doc.text("Sr. Training Manager", 57, 270);

        doc.addImage('../../../assets/images/bage.png', 'PNG', 260, 205, 52, 70);
        doc.addImage('../../../assets/images/divakarSign.png', 'PNG', 420, 225, 65, 20);
        doc.setFont('normal');
        doc.setLineWidth(0.5);
        doc.line(498, 245, 415, 245);
        doc.setFontSize(12);
        doc.setTextColor(35, 66, 145);
        doc.text("Diwakar Dubey", 425, 255);
        doc.text("Training Manager", 420, 270);
      }
    }else{

      doc.setFontSize(25);
      doc.setTextColor(67, 67, 67);
      doc.text("This is to Certify that " +`" `  + fullName + `"`, width / 2, 123, { align: 'center' });
      doc.setFontSize(25);
      doc.setTextColor(67, 67, 67);
      doc.text(" has successfully completed", width / 2, 143, { align: 'center' });
      if(this.CourseData.length < 50){
        doc.setLineWidth(0.5);
        // doc.line(270, 132, 210, 132);
        doc.setFontSize(27);
        doc.setTextColor(67, 67, 67);
        doc.text(`" ` + this.CourseData + `" `+ " on " + this.currentData + "", width / 2, 175, { align: 'center' });

        doc.addImage('../../../assets/images/ashish_sign.png', 'PNG', 65, 225, 60, 18);
        doc.setFont('normal');
        doc.setLineWidth(0.5);
        doc.line(50, 245, 140, 245);
        doc.setFontSize(12);
        doc.setTextColor(35, 66, 145);
        doc.text("Ashish Agarwal", 63, 255);
        doc.text("Sr. Training Manager", 57, 270);

        doc.addImage('../../../assets/images/bage.png', 'PNG', 260, 205, 52, 70);
        doc.addImage('../../../assets/images/divakarSign.png', 'PNG', 420, 225, 65, 20);
        doc.setFont('normal');
        doc.setLineWidth(0.5);
        doc.line(498, 245, 415, 245);
        doc.setFontSize(12);
        doc.setTextColor(35, 66, 145);
        doc.text("Diwakar Dubey", 425, 255);
        doc.text("Training Manager", 420, 270);
      }else{
        doc.setLineWidth(0.5);
        // doc.line(270, 132, 210, 132);
        doc.setFontSize(27);
        doc.setTextColor(67, 67, 67);
        doc.text(`" ` + this.CourseData + `" `, width / 2, 175, { align: 'center' });

        doc.setFontSize(27);
        doc.setTextColor(67, 67, 67);
        doc.text(" on " + this.currentData + "", width / 2, 195, { align: 'center' });

        doc.addImage('../../../assets/images/ashish_sign.png', 'PNG', 65, 240, 60, 18);
        doc.setFont('normal');
        doc.setLineWidth(0.5);
        doc.line(50, 260, 140, 260);
        doc.setFontSize(12);
        doc.setTextColor(35, 66, 160);
        doc.text("Ashish Agarwal", 63, 270);
        doc.text("Sr. Training Manager", 57, 285);

        doc.addImage('../../../assets/images/bage.png', 'PNG', 260, 220, 52, 70);
        doc.addImage('../../../assets/images/divakarSign.png', 'PNG', 420, 240, 65, 20);
        doc.setFont('normal');
        doc.setLineWidth(0.5);
        doc.line(498, 260, 415, 260);
        doc.setFontSize(12);
        doc.setTextColor(35, 66, 160);
        doc.text("Diwakar Dubey", 425, 270);
        doc.text("Training Manager", 420, 285);
      }
    }

    return doc;

    // doc.save(course_name +"_certificate.pdf");
    //  alert(course_name)
    // this.router.navigate(['/completed']);
  }

}


